import { environment } from './../../environments/environment';

export class FileNumberUtil {

   /**
    * part role code and description map
    */
   static partyRoleMapFromDescToCode: Map<string, string> = new Map<string, string>(
        [['BENEFICIARY / DEVISEE', 'B'],
         ['DEFENDANT', 'D'],
         ['ESTATE', 'E'],
         ['FIDUCIARY', 'F'],
         ['INTERESTED PARTY', 'I'],
         ['PLAINTIFF / PETITIONER', 'P'],
         ['RESPONDENT', 'R'],
         ['SURETY', 'S'],
         ['TITLE', 'T']]);

  /**
   * get the case type for the case number (i.e file number)
   * @param caseNumber string
   */
  static getCaseType(caseNumber: string): string {

    const input = caseNumber || '';

    const letters = input.match(/[a-zA-Z]+/g);
    if (letters === null) {
        return '';
    }
    return letters.length ? letters.join('') : '';
  }

  /**
   * get the case type description for the given case type (i.e. case type code)
   * @param caseType string
   */
  static getCaseTypeDescription(caseType: string): string {
        let caseTypeName = '';
        if (caseType === 'CVD') {
            caseTypeName = 'CIVIL DISTRICT';
        } else if (caseType === 'CVS') {
            caseTypeName = 'CIVIL SUPERIOR';
        } else if (caseType === 'CVM') {
            caseTypeName = 'CIVIL MAGISTRATE';
        } else if (caseType === 'CR') {
            caseTypeName = 'CRIMINAL DISTRICT';
        } else if (caseType === 'CRS') {
            caseTypeName = 'CRIMINAL SUPERIOR';
        } else if (caseType === 'E') {
            caseTypeName = 'ESTATE';
        } else if (caseType === 'EO') {
            caseTypeName = 'ESTATE OTHER';
        } else if (caseType === 'IF') {
            caseTypeName = 'INFRACTION';
        } else if (caseType === 'IFS') {
            caseTypeName = 'INFRACTION SUPERIOR';
        } else if (caseType === 'J') {
            caseTypeName = 'JUVENILE';
        } else if (caseType === 'M') {
            caseTypeName = 'MISCELLANEOUS';
        } else if (caseType === 'R') {
            caseTypeName = 'REGISTRATION';
        } else if (caseType === 'SP') {
            caseTypeName = 'SPECIAL PROCEEDING';
        } else if (caseType === 'T') {
            caseTypeName = 'TRANSCRIPT';
        } else {
            caseTypeName = 'UNKNOWN';
        }
        return caseTypeName;
    }

 /**
   * get the case type description for the given case type (i.e. case type code)
   * @param caseType string
   */
  static getLongCourtTypeDescription(caseType: string): string {
        let courtTypeName = '';
        if (caseType === 'CVD') {
            courtTypeName = 'DISTRICT COURT CIVIL ACTION';
        } else if (caseType === 'CVS') {
            courtTypeName = 'SUPERIOR COURT CIVIL ACTION';
        } else if (caseType === 'CVM') {
            courtTypeName = 'CIVIL MAGISTRATE';
        } else if (caseType === 'CR') {
            courtTypeName = 'CIVIL JUDGMENT on a CRIMINAL CASE';
        } else if (caseType === 'CRS') {
            courtTypeName = 'CIVIL JUDGMENT on a CRIMINAL CASE';
        } else if (caseType === 'E') {
            courtTypeName = 'DECEDENT ESTATE';
        } else if (caseType === 'EO') {
            courtTypeName = 'ESTATE OTHER';
            /* TODO  FBR528
                E: DECEDENT ESTATE (for Estate cases with new case subtype)
                E: GUARDIANSHIP (for Estate cases with new case subtype)
                E: TRUST (for Estate cases with new case subtype)
            */
        } else if (caseType === 'J') {
            courtTypeName = 'CIVIL JUDGMENT on a JUVENILE CASE';
        } else if (caseType === 'M') {
            courtTypeName = 'MISCELLANEOUS';
        } else if (caseType === 'R') {
            courtTypeName = 'REGISTRATION';
        } else if (caseType === 'SP') {
            courtTypeName = 'SPECIAL PROCEEDING';
        } else {
            courtTypeName = caseType;
        }
        return courtTypeName;
    }
   /**
    * get the party role code for the given party role description
    * @param partyRoleDesc
    */
   static getPartyRoleCode(partyRoleDesc: string) {
    if (!partyRoleDesc) {
        return '';
    }
    const partRoleCode = this.partyRoleMapFromDescToCode.get(partyRoleDesc.trim());
    return partRoleCode || '';
   }

  /**
   * get the century based on the two digits of the year
   * (copied the logic from java common)
   */
  private static getCenturyFromYear(year: string): string {
    let date: Date = new Date();
    let yy: number = Number(year);

    // TODO: this two condition to be removed...
    if (yy >= 1000) {
       return this.padString(year, 2, '0');
    }
    if (yy >= 100) {
       return this.padString('1900' + yy, 2, '0');
    }

    let todayYear: number = date.getFullYear();
    let todayYy: number = Number.parseInt((todayYear + '' ).substr(2));
    let cutoffYear: number = (todayYear + 50) % 100;
    let century: number = Number.parseInt('' + (todayYear / 100));
     // console.log('yy = ' + yy +' today year = ' + todayYear + '  cutoff year =' + cutoffYear  + ' century = ' + century);

    if (yy > todayYy) {
        return this.padString('' + (century - 1), 2, '0');
    } else if (cutoffYear >= 50) {
      if (yy < cutoffYear ) {
         return this.padString('' + century, 2, '0');
      } else {
         return this.padString('' + (century - 1), 2, '0');
      }
    } else {
      if (yy < cutoffYear) {
        return this.padString('' + (century + 1), 2, '0');
      } else {
        return this.padString('' + century, 2, '0');
      }
    }
  }

  /**
   * padding chars to a string
   * @param inText
   * @param length
   * @param padChar
   */
  private static padString(inText: string, length: number, padChar: string): string {
    if (inText == null) {
      inText = '';
    }

    let result: string = inText;
    while (result.length < length) {
      result =  result.concat(padChar);
    }
    return result;
  }

  /**
   *  strip the middle zeros in the case number e.g 2016CVM000001 to 2016CVM1 or 2004CVS002569 to 2004CVS2569
   * @param caseNumber string
   */
  public static stripMiddleZeros(caseNumber: string): string  {
     let caseType = this.getCaseType(caseNumber);
     if (caseType === '') {
        return caseNumber;  //  do not need to strip
     }
     let typeIdx: number = caseNumber.indexOf(caseType);
     let digitStartIdx: number = typeIdx + caseType.length;
     let prefixPart: string = caseNumber.substring(0, digitStartIdx);
     let suffixStartIdx: number = digitStartIdx;   // suffix start point
     for (let idx = digitStartIdx; idx < caseNumber.length;  idx++) {
         let c: string = caseNumber.charAt(idx);
         if (c === '0' || c === ' ') {
             continue;
         }  else {
             suffixStartIdx = idx;  // suffix part from the first none-0
             break;
         }
     }

     let suffixPart: string = caseNumber.substring(suffixStartIdx);

     return (prefixPart + suffixPart);
  }

  /**
   * normalize a case number by adding century and stripping off the middle zeros e.g 16CVM000001  to 2016CVM1
   * @param caseNumber string
   */
  static normalizeCaseNumber(caseNumber: string ): string {
    if (!caseNumber || caseNumber.trim() === '') {
        return '';
    }

    // removed the white spaces
    caseNumber = caseNumber.replace(/\s/g, '');

    // currently ws only accepts the CCYY for the year
    let isCaseNumberWithoutYear: boolean =  /^[a-zA-Z]/.test(caseNumber);
    let caseNumberWithCentury: string = null;
    if (isCaseNumberWithoutYear) {
       let currentYear = new Date().getFullYear();
       caseNumberWithCentury = currentYear + caseNumber;
    } else {
       caseNumberWithCentury =  (/\d{4}[a-zA-Z]/.test(caseNumber)) ?
          caseNumber : (this.getCenturyFromYear(caseNumber.substr(0, 2)) + caseNumber);
    }

    let caseNumberWithoutMiddleZeros = this.stripMiddleZeros(caseNumberWithCentury);

    // logging in development environment
    // if (!environment.production) {
    // console.log('case number input = ' + caseNumber + ' and case number normalized =' + caseNumberWithoutMiddleZeros);
    // }

    return caseNumberWithoutMiddleZeros;
  }


   /**
   * normalize a case number without the century, if there is, strip them out;
   * and stripping off the middle zeros e.g 2016CVM000001  to 16CVM1
   * @param caseNumber string
   */
  static normalizeCaseNumberWithoutCentury(caseNumber: string ): string {
    const normalizedCaseNumber = FileNumberUtil.normalizeCaseNumber(caseNumber);
    if (normalizedCaseNumber === '') {
      return '';
    }
    return normalizedCaseNumber.substr(2);
  }

  /**
   * padding middle zeros to the case number
   * @param caseNumber string
   */
  static paddingMiddleZeros(caseNumber: string): string {
    let caseType: string = FileNumberUtil.getCaseType(caseNumber);
    let caseTypeIndex: number = caseNumber.indexOf(caseType);
    let seqIndex =  caseTypeIndex + caseType.length;
    let seqNumber = caseNumber.substr(seqIndex).trim();
    let seqLength = seqNumber.length;
    while (seqLength < 6) { // adding middle zeros
       caseNumber = caseNumber.slice(0, seqIndex) + '0' + caseNumber.slice(seqIndex);
       seqLength++
    }
    return caseNumber;
  }

  /**
   * normalize the string to remove the beginning and ending spaces ,
   * and the middle spaces to one space.
   * @param input
   */
  public static normalizeRegularString(input: string): string {
    const str = input || '';
    return str.replace(/^\s+|\s+$/gm, '').replace(/\s+/gm, ' ');
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/file-number-util.ts